import { createApp } from 'vue'
import { createPinia } from 'pinia'
import components from './components.js'
import { useAuthStore } from './src/store/auth.js'


import '../css/app.css'


import { defineRule, configure, Form, Field, ErrorMessage } from 'vee-validate'


// Frontend Filters
// Vue 3 doesn't have global filters, we'll need to use a different approach for these
import './src/filters/filters.js'


// 3rd party plugins
import axiosIns from './src/plugins/axios.js'



// Lazy-load SweetAlert2 (only when first used)
window.Swal = new Proxy({}, {
  get(_, prop) {
    return (...args) => {
      return import('sweetalert2').then(({ default: Swal }) => {
        window.Swal = Swal;
        return Swal[prop](...args);
      });
    };
  }
});


// Create the pinia instance
const pinia = createPinia()


// Create the app instance
const app = createApp({})


// Use pinia with the app
app.use(pinia)


// Initialize auth store with data from Laravel
const authStore = useAuthStore()
if (window.initialData) {
  authStore.initAuth(window.initialData)
}


// Register axios as a global property (Vue 3 approach instead of Vue.prototype)
app.config.globalProperties.$http = axiosIns


// Register the VeeValidate components globally
app.component('VForm', Form)
app.component('VField', Field)
app.component('VErrorMessage', ErrorMessage)


// Register all components
Object.keys(components).forEach((name) => {
    if (!components[name]) {
        console.error(`Component ${name} not found`)
    } else {
        app.component(name, components[name])
    }
})


// Mount the app
app.mount('#app')

